<div fxLayout="row" fxLayoutAlign="space-around center" class="full-height">
    <div fxLayout="column" fxLayoutAlign="center stretch">
        <div fxFlex><mat-icon class="large-icon">broken_image</mat-icon></div>
        <div fxFlex class="align-center" *ngIf="message">{{message}}</div>
    </div>
</div>
